import * as React from 'react';
import { addClass } from '../../utils';
import './Separator.css';
export const Separator = ({ className }) => React.createElement("hr", { className: addClass('vai-separator', className) });
//# sourceMappingURL=Separator.js.map